import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

//Given a state id, we can get all the districts and its blocks. State id OR for Odisha
export const getAllBlocksThunk = createAsyncThunk(
  "getAllTheBlocks",
  async (id) => {
    let response = await api.get("getallblocksanddistrictsbystatecode/" + id);
    return response.data;
  }
);

//To create a state wise data
export const postNewBlockThunk = createAsyncThunk(
  "postABlock",
  async (body) => {
    let response = await api.post("createnewblockdistrict", body);
    return response.data;
  }
);

//For deleting an existing data
export const deleteBlockDataThunk = createAsyncThunk(
  "deleteBlockData",
  async (id) => {
    let response = await api.delete("deleteblockdistrictbyid/" + id);
    return response.data;
  }
);

//we get a list of all the states and their districts.
export const getAllDistrictsThunk = createAsyncThunk(
  "getAllOdishaDistricts",
  async () => {
    const response = await api.get("getallstateanddistricts/");
    return response.data;
  }
);
